
$(document).ready(function () {
  let storeURL = window.location.origin;

  // Global helper to handle exclusive applying
  window.applyExclusiveCoupon = async function (newCoupon, $btn, $errorEl) {
    console.log(`[Coupon] applyExclusiveCoupon called with: ${newCoupon}`);
    try {
      // 1. Loading state
      const originalText = $btn.text();
      $btn.text('Applying...').prop('disabled', true);
      $errorEl.text("");
      console.log('[Coupon] Step 1: Loading state set');

      // 2. Clear any existing coupons to ensure exclusivity
      console.log('[Coupon] Step 2: Clearing active discounts...');
      const clearResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
      console.log('[Coupon] Step 2 response status:', clearResponse.status);

      if (!clearResponse.ok) {
        console.error('[Coupon] Step 2 FAILED - response not OK:', clearResponse.statusText);
        throw new Error('Failed to clear discounts: ' + clearResponse.statusText);
      }

      // 3. Apply the new coupon via Shopify redirect
      const redirectUrl = storeURL + `/discount/${newCoupon}?redirect=/cart`;
      console.log('[Coupon] Step 3: Redirecting to:', redirectUrl);
      window.location.href = redirectUrl;
    } catch (error) {
      console.error('[Coupon] Error in applyExclusiveCoupon:', error);
      $errorEl.text("Failed to apply coupon. Please try again.");
      $btn.text('Apply').prop('disabled', false);
    }
  };

  // Global helper to handle exclusive removal
  window.removeSpecificCoupon = async function (couponToRemove, $btn) {
    console.log(`[Coupon] Removing ${couponToRemove}...`);
    try {
      // 1. Loading state
      let originalText = "Remove";
      if ($btn && $btn.length) {
        originalText = $btn.text();
        $btn.text('Removing...').prop('disabled', true);
      }

      const cart = await fetch('/cart.js').then(res => res.json());

      // Determine if another targeted coupon should be preserved
      let discountToStay = '';
      if (couponToRemove === 'MULTISENSORY') {
        const hasDiscountGifted = cart.discount_codes?.some(d => d.code?.toUpperCase() == 'GIFTED');
        if (hasDiscountGifted) discountToStay = 'GIFTED';
      } else if (couponToRemove === 'GIFTED') {
        const hasDiscountMultisensory = cart.discount_codes?.some(d => d.code?.toUpperCase() == 'MULTISENSORY');
        if (hasDiscountMultisensory) discountToStay = 'MULTISENSORY';
      }

      console.log(`[Coupon] discountToStay after removal: ${discountToStay || 'none'}`);

      let redirectURL = '/cart';
      if (discountToStay) {
        redirectURL = window.location.origin + `/discount/${discountToStay}?redirect=/cart`;
      }

      // Clear ALL current coupons first. Simply passing the one to stay doesn't consistently
      // remove the others if multiple are present in cart.discount_codes.
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });

      console.log('[Coupon] Cleared existing discounts. Redirecting...');
      window.location.href = redirectURL;
    } catch (error) {
      console.error('[Coupon] Error in removeSpecificCoupon:', error);
      if ($btn && $btn.length) {
        $btn.text(originalText).prop('disabled', false); // Error state recovery
      }
    }
  };

  $(".apply-coupon-button-ajax").click(async function (e) {
    e.preventDefault();
    console.log('[Coupon] Apply button clicked');

    const $btn = $(this);
    const $input = $btn.siblings("#coupon-code");
    console.log('[Coupon] Input element found:', $input.length > 0, 'Value:', $input.val());

    // Fallback: also try finding input within parent container if siblings() fails
    const couponCodeVal = ($input.val()?.trim()) ||
      ($btn.closest(".coupon-box-styles").find("#coupon-code").val()?.trim()) ||
      "";
    console.log('[Coupon] Resolved couponCodeVal:', couponCodeVal);

    const $errorEl = $btn.closest(".coupon-box-styles").find(".coupon-not-found-error");
    console.log('[Coupon] Error element found:', $errorEl.length > 0);

    if (!couponCodeVal) {
      console.log('[Coupon] Empty coupon code, showing error');
      $errorEl.text("Please enter a valid coupon"); // Empty state handling
      return;
    }

    const upperCoupon = couponCodeVal.toUpperCase();
    console.log('[Coupon] Uppercase coupon:', upperCoupon);

    if (upperCoupon === 'MULTISENSORY' || upperCoupon === 'GIFTED') {
      console.log('[Coupon] Valid coupon detected, calling applyExclusiveCoupon...');
      await window.applyExclusiveCoupon(upperCoupon, $btn, $errorEl);
    } else {
      console.log('[Coupon] Invalid coupon:', upperCoupon);
      $errorEl.text("Please enter a valid coupon");
    }
  });

});

document.addEventListener('DOMContentLoaded', function () {
  const multisensoryCouponBox = document.querySelector('.applied-coupon-box.multisensory');
  const giftedCouponBox = document.querySelector('.applied-coupon-box.gifted');
  // Handle case where element might not exist
  const couponText = document.getElementById('applied-coupon-code');

  const removeBtnMultisensory = document.querySelector('.remove-coupon.multisensory');
  const removeBtnGifted = document.querySelector('.remove-coupon.gifted');

  // --- Check which coupon is active and show/hide the UI ---
  function checkCoupon() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const hasDiscount = cart.discount_codes?.some(
          d => d.code?.toUpperCase() == 'MULTISENSORY' && d.applicable
        );
        if (multisensoryCouponBox) {
          if (cart.discount_codes && hasDiscount) {
            multisensoryCouponBox.style.display = 'flex';
            if (couponText) couponText.textContent = 'MULTISENSORY';
          } else {
            multisensoryCouponBox.style.display = 'none';
          }
        }

        const hasDiscountGifted = cart.discount_codes?.some(
          d => d.code?.toUpperCase() == 'GIFTED' && d.applicable
        );
        if (giftedCouponBox) {
          if (cart.discount_codes && hasDiscountGifted) {
            giftedCouponBox.style.display = 'flex';
          } else {
            giftedCouponBox.style.display = 'none';
          }
        }
      })
      .catch(err => {
        console.error('[Coupon] Error checkCoupon logic:', err);
      });
  }

  // --- Remove coupon buttons ---
  if (removeBtnMultisensory) {
    removeBtnMultisensory.addEventListener('click', async function () {
      await window.removeSpecificCoupon('MULTISENSORY', $(this));
    });
  }

  if (removeBtnGifted) {
    removeBtnGifted.addEventListener('click', async function () {
      await window.removeSpecificCoupon('GIFTED', $(this));
    });
  }

  checkCoupon();

  // --- MULTISENSORY: ensure original variant is in cart when coupon is present ---
  async function handleMultisensoryAutoAdd() {
    var originalVariantID = 43324949332042;
    var sampleVariantID = 43324949364810;

    console.log('[MULTISENSORY] originalVariantID:', originalVariantID, 'sampleVariantID:', sampleVariantID);
    if (!originalVariantID) return;

    let cart = await fetch('/cart.js?v=' + Date.now()).then(r => r.json());
    console.log('[MULTISENSORY] Cart state:', cart);

    // Check if MULTISENSORY discount code is present at all
    const multisensoryDiscount = cart.discount_codes?.find(
      d => d.code?.toUpperCase() === 'MULTISENSORY'
    );
    if (!multisensoryDiscount) return;

    const originalInCart = cart.items.find(i => i.variant_id == originalVariantID);
    const sampleInCart = cart.items.find(i => i.variant_id == sampleVariantID);

    // Case 1: Original already in cart — nothing to do
    if (originalInCart) {
      console.log('[MULTISENSORY] Original variant already in cart. No action needed.');
      return;
    }

    // Case 2: Sample is in cart — swap it for original (remove sample, add original)
    if (sampleInCart) {
      console.log('[MULTISENSORY] Sample variant found. Swapping for original...');
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [sampleInCart.key]: 0 } })
      });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: originalVariantID, quantity: sampleInCart.quantity }] })
      });
      console.log('[MULTISENSORY] Swap complete. Reloading...');
      location.reload();
      return;
    }

    // Case 3: Neither in cart — speculatively add original, verify applicability
    console.log('[MULTISENSORY] Adding original variant to cart...');
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: originalVariantID, quantity: 1 }] })
    });

    cart = await fetch('/cart.js?v=' + Date.now()).then(r => r.json());
    const updatedDiscount = cart.discount_codes?.find(
      d => d.code?.toUpperCase() === 'MULTISENSORY'
    );

    if (updatedDiscount && updatedDiscount.applicable) {
      console.log('[MULTISENSORY] Coupon applicable. Reloading...');
      location.reload();
      return;
    }

    // Not applicable — rollback
    console.warn('[MULTISENSORY] Coupon not applicable. Rolling back...');
    const addedItem = cart.items.find(i => i.variant_id == originalVariantID);
    if (addedItem) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [addedItem.key]: 0 } })
      });
    }
  }

  handleMultisensoryAutoAdd();

  // --- Gift → Original swap (runs only on cart page) ---
  let currentURL = window.location.href;

  if (currentURL.includes('/cart')) {
    const giftToOriginalMapping = [
      { original: '41498714341450', gift: '43342943682634' },
      { original: '41498716635210', gift: '43342967210058' },
      { original: '41498726432842', gift: '43342973403210' },
      { original: '41498723156042', gift: '43342972813386' },
      { original: '41498724335690', gift: '43342973763658' },
      { original: '41730973433930', gift: '43342974189642' }
    ];

    async function handleGiftToOriginalSwap() {
      const cart = await fetch('/cart.js?v=' + Date.now()).then(r => r.json());

      const itemsToSwap = [];
      const removals = {};

      cart.items.forEach(item => {
        const mapping = giftToOriginalMapping.find(m => m.gift == item.variant_id);
        if (mapping) {
          itemsToSwap.push({ id: mapping.original, quantity: item.quantity });
          removals[item.key] = 0;
        }
      });

      if (itemsToSwap.length === 0) return;

      console.log('[GIFT-SWAP] Found gift variants. Swapping back to originals...', itemsToSwap);

      // 1. Remove all gift variants
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: removals })
      });

      // 2. Add all original variants
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToSwap })
      });

      console.log('[GIFT-SWAP] Swap complete. Reloading...');
      location.reload();
    }

    handleGiftToOriginalSwap();
  }

});
